import React from "react";

import { useIntl } from "react-intl";

import SchemaFieldCategory from "@mapmycustomers/shared/enum/SchemaFieldCategory";
import SchemaFieldType from "@mapmycustomers/shared/enum/SchemaFieldType";
import CustomField from "@mapmycustomers/shared/types/customField/CustomField";
import SchemaField from "@mapmycustomers/shared/types/schema/SchemaField";

import CustomFieldTypeCell from "@app/scene/settings/component/CustomFields/component/CustomFieldTypeCell";
import { getSchemaFieldCategoryDisplayName } from "@app/util/ui";

interface Props {
  customField?: CustomField;
  field: SchemaField;
}

const FieldType: React.FC<Props> = ({ customField, field }) => {
  const intl = useIntl();

  if (field.fieldType === SchemaFieldType.CUSTOM) {
    if (field.customFieldId && customField) {
      return (
        <CustomFieldTypeCell isCalculated={customField.isCalculated} type={customField.dataType} />
      );
    }
  } else {
    return (
      <span>
        {getSchemaFieldCategoryDisplayName(intl, field.category ?? SchemaFieldCategory.STANDARD)}
      </span>
    );
  }

  return null;
};

export default FieldType;
